import { getOr, head, pipe } from 'lodash/fp';
import { useCallback } from 'react';

// for secure content property parsing
export const useSDLContent = (contentInfo: any) => {
  const parseContentRawProp = useCallback(
    (field: string) =>
      pipe(
        head, // get first element
        getOr('{}', [field, 'raw']), // get field raw value
        JSON.parse, // parsing json content
      )(contentInfo),
    [contentInfo],
  );

  return {
    parseContentRawProp,
  };
};
